
import * as React from 'react';
const { useState, useEffect } = React;
import ImageManager from './media/ImageManager';
import { logger, criticalLogger } from '@/utils/logger';

// Storage constants for the cloned version
const CLONED_HERO_IMAGE_KEY = 'cloned_hero_image';
const CLONED_HERO_UPDATED_EVENT = 'cloned-hero-image-updated';

// Default hero image
const DEFAULT_HERO_IMAGE = '/lovable-uploads/649c6121-e816-4934-81d7-2874066c9c4e.png';

const ClonedPrayersHero = () => {
  const [heroImage, setHeroImage] = useState(DEFAULT_HERO_IMAGE);

  useEffect(() => {
    // Force override any previously saved hero image with the new default
    try {
      localStorage.setItem(CLONED_HERO_IMAGE_KEY, DEFAULT_HERO_IMAGE);
      window.dispatchEvent(new Event(CLONED_HERO_UPDATED_EVENT));
    } catch (error) {
      criticalLogger.error('Error overriding cloned hero image in localStorage:', error);
    }

    // Load the hero image from localStorage when component mounts
    const loadHeroImage = () => {
      try {
        const storedImage = localStorage.getItem(CLONED_HERO_IMAGE_KEY);
        if (storedImage) {
          logger.log('Loading cloned hero image from localStorage:', storedImage.substring(0, 50) + '...');
          setHeroImage(storedImage);
        } else {
          logger.log('No stored cloned hero image found, using default');
          setHeroImage(DEFAULT_HERO_IMAGE);
        }
      } catch (error) {
        criticalLogger.error('Error loading cloned hero image from localStorage:', error);
        setHeroImage(DEFAULT_HERO_IMAGE);
      }
    };

    loadHeroImage();

    // Listen for storage events to update the image if changed in another tab
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === CLONED_HERO_IMAGE_KEY) {
        logger.log('Cloned hero image updated in another tab, refreshing');
        loadHeroImage();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Listen for custom event for image updates within the same tab
    const handleCustomEvent = () => {
      logger.log('Cloned hero image updated in this tab, refreshing');
      loadHeroImage();
    };
    
    window.addEventListener(CLONED_HERO_UPDATED_EVENT, handleCustomEvent);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener(CLONED_HERO_UPDATED_EVENT, handleCustomEvent);
    };
  }, []);

  return (
    <div className="w-full overflow-hidden -mt-4">
      <div className="relative w-full" style={{ aspectRatio: 2.35 }}>
        <ImageManager
          type="hero"
          src={heroImage}
          alt="Cloned hero background"
          className="w-full h-full"
          fallbackSrc={DEFAULT_HERO_IMAGE}
        />
      </div>
    </div>
  );
};

export default ClonedPrayersHero;
